<!-- <!DOCTYPE html> -->
<template lang="pug">
  div.thread-input-box.thread-input-maxwidth(:class="{'has-text': message.length > 0 || ishover}" @mouseleave="ishover = false" @mouseover="ishover = true" @dragover.prevent="handleThreadDragOver" @dragleave.prevent="handleThreadDragLeave" @drop.prevent="handleThreadDrop")
    multipleFileThumbnail(
      ref="multipleFileRef"
      :showDropArea="false"
      :uploadBtnText="'Save'"
      :progressBtnText="'Saving...'"
      :uploadedFiles="files"
      :isUploading="isUploading"
      :schedule_access="true"
      :accept="acceptFileTypes"
      @addAttachmentData="addAttachmentData"
      @showErrorDialog="showErrorDialog"
    )
    div.textarea-field
      textarea.customer-textarea-field.input-field-upper.custom-height.h5-en-regular.ma-0.pa-0.d-flex.align-end.custom-text-field.v-input__control(v-model="message" placeholder="New Thread" rows="2" ref="autoTextarea" :rules="formRules.massTextAreaRule"  style="resize:none;" @input="autoTextareaGrow" @keydown.enter.exact.prevent="sendMessage")

    div.pt-1.px-4.d-flex.top-hr-line.bottom-hr-line.align-center(style="border-bottom-width: 0px;")
      // 在mobile狀態下顯示
      v-btn.kw-box.d-flex.justify-start.align-center.custom-btn(v-if="$vuetify.breakpoint.smAndDown" @click="drawer = !drawer" color="transparent" icon)
        v-avatar.kw-button.avatar-effect(icon size="24")
          v-img(contain height="21.5px" src="@/assets/images/knowledge_select.svg"
          width="21px")
      v-navigation-drawer.menu-drawer(v-model="drawer" v-if="$vuetify.breakpoint.smAndDown" mobile hide-overlay bottom style="position: fixed; height: unset; z-index: 100;" )
        template
          v-card()
            v-list(flat style="max-height: 290px !important;")
              // --------- 搜尋網頁 開關 ---------
              div.br-0.d-flex.align-center.justify-space-between(v-if="$store.state.webSearchEnabled && $store.state.portalWebSearchEnabled" style='height:40px;')
                div.ml-4.d-flex.align-center.justify-start()
                  v-img.mr-1(contain height="21.5px" src="@/assets/images/search_web.svg" width="21px")
                  label.label_title(style='color:#444444; font-weight: 400; font-size: 14px;') {{$t('AGENT.SEARCH_WEB')}}
                div.mr-3.d-flex.align-center
                  v-switch.mb-1.keep-white-thumb(v-model='canSearchWeb' dense flat inset :ripple="false" :color="toggle_setting")
                  label(v-if='canSearchWeb' style='color:#444444; font-weight: 400; font-size: 14px;') {{$t("GPT_KNOWLEDGE.OPEN_LIB")}}
                  label(v-else style='color:#444444; font-weight: 400; font-size: 14px;') {{$t("GPT_KNOWLEDGE.CLOSE_LIB")}}
              v-divider.my-0(v-if="$store.state.webSearchEnabled && $store.state.portalWebSearchEnabled")
              // --------- 知識庫 開關 ---------
              div.br-0.d-flex.align-center.justify-space-between(style='height:40px;')
                div.ml-4.d-flex.align-center.justify-start()
                  v-img.mr-1(contain height="21.5px" src="@/assets/images/knowledge_select.svg" width="21px")
                  label.label_title(style='color:#444444; font-weight: 400; font-size: 14px;') {{$t('AGENT.KNOWLEDGE_LIBS')}}
                div.mr-3.d-flex.align-center
                  v-switch.mb-1.keep-white-thumb(v-model='canUseKB' dense flat inset :ripple="false" :color="toggle_setting")
                  label(v-if='canUseKB' style='color:#444444; font-weight: 400; font-size: 14px;') {{$t("GPT_KNOWLEDGE.OPEN_LIB")}}
                  label(v-else style='color:#444444; font-weight: 400; font-size: 14px;') {{$t("GPT_KNOWLEDGE.CLOSE_LIB")}}
              v-divider.my-0
              // -------- 全選列 --------
              div.br-0.d-flex.align-center(v-if='canUseKB' style='height:40px; width:240px;')
                div.ml-2.d-flex.align-center.justify-start()
                  v-btn(style='margin-left: -2px;' icon :color="unselectAllKM ? '' : checkbox_setting" @click='activeTriggerAllKM()')
                    v-icon(:color="unselectAllKM ? '' : checkbox_setting" size='22') {{ selectALLKMIconDesider() }}
                  label.label_title(style='color:#444444; font-weight: 400; font-size: 14px;') {{$t('GENERAL.SELECTALL')}}
              v-divider.my-0(v-if='canUseKB')
              div.partial-kmlist-mobile(v-if='canUseKB')
                // ======= 收藏區 =======
                template(v-if="knowledgeFavorites.length > 0")
                  div.d-flex.align-center.px-3(style='height:32px;')
                    v-icon(size='14' color='#14C6DE') mdi-star
                    span.ml-1(style='color:#444; font-size:14px; font-weight:500;') {{$t('PORTAL.FAVORITES')}}
                  v-list-item-group(multiple)
                    v-list-item.pr-0(v-for="item in knowledgeFavorites" :key="`m-fav-${item.id}`" @click.stop style="min-height: 36px !important;")
                      template(v-slot:default="{ active }")
                        v-list-item-action.ma-0.mr-2
                          v-checkbox.ma-0(v-model='currentselect' :value='item' :value-comparator="(a, b) => a.id === b.id" :color="checkbox_setting")
                        v-list-item-content.pa-0(style="display: inline;")
                          v-avatar(size='20' max-height='20' :color='getColorFromKnowledgeName(item.name)' left class="mr-2")
                            span(style='padding-bottom:1px;') {{item.name.slice(0,1)}}
                          span(style='color:#444444; font-weight: 400; font-size: 14px;') {{item.name.split('@')[0]}}
                        v-list-item-action.ma-0
                          v-btn(icon x-small @click.stop="toggleFavorite(item)")
                            v-icon(size='20' color='#14C6DE') mdi-star
                  v-divider.my-0
                // ======= Folder-first Checkbox 樹 =======
                template(v-for="node in flattenedTree")
                  div.d-flex.align-center.tree-folder-row(
                    v-if="node.type === 'folder'"
                    :key="`m-folder-${node.id}`"
                    :style="treeNodeStyle(node)"
                    @click.stop
                  )
                    v-btn.pa-0(icon x-small @click.stop="toggleFolder(node.id)" style='width:18px; height:18px; min-width:18px;')
                      v-icon(size='14' color='#888') {{ expandedFolderIds.includes(String(node.id)) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                    v-btn(icon :color="getFolderCheckState(node.id) !== 'none' ? checkbox_setting : ''" @click.stop="toggleFolderSelection(node)" style='margin-left:-2px;')
                      v-icon(:color="getFolderCheckState(node.id) !== 'none' ? checkbox_setting : ''" size='22') {{ getFolderCheckIcon(node.id) }}
                    v-img.mr-1(src="@/assets/images/folder-btn.svg" max-height="20" max-width="20" contain)
                    span.tree-node-name(style='color:#444444; font-weight: 400; font-size: 14px;') {{ node.name }}
                  v-hover(v-else-if="node.type === 'library'" :key="`m-lib-${node.id}`" v-slot="{ hover }")
                    div.d-flex.align-center(
                      :style="treeNodeStyle(node)"
                      @click.stop
                    )
                      v-checkbox.mr-0.ml-3.my-0(v-model='currentselect' :value='libraryNodeMap[node.id]' multiple :value-comparator="(a, b) => a.id === b.id" :color="checkbox_setting" @click.stop)
                      v-avatar.ml-3(size='20' max-height='20' :color='getColorFromKnowledgeName(node.name)' left class="mr-2")
                        span(style='padding-bottom:1px;') {{ node.name.slice(0,1) }}
                      span.tree-node-name(style='color:#444444; font-weight: 400; font-size: 14px;') {{ node.name.split('@')[0] }}
                      v-spacer
                      v-btn(v-show="hover || localFavoriteIds.includes(node.id)" icon x-small @click.stop="toggleFavorite(node)" style='margin-right:4px;')
                        v-icon(size='20' :color="localFavoriteIds.includes(node.id) ? '#14C6DE' : '#bbb'") {{ localFavoriteIds.includes(node.id) ? 'mdi-star' : 'mdi-star-outline' }}
                // ======= 私人知識庫 =======
                div.p1-en-regular.ml-2(style="color:#444444; font-weight: 400; font-size: 14px;" v-if="knowledgeListPrivate.length !== 0") {{$t("PORTAL.MY_KNOWLEDGE")}}
                v-list-item-group(multiple v-if="knowledgeListPrivate.length !== 0")
                  v-list-item.pr-0.pl-3(v-for="item in knowledgeListPrivate" :key="item.id" @click.stop style="min-height: 38px !important;")
                    template(v-slot:default="{ active }")
                      v-list-item-action.mr-2.my-2
                        v-checkbox.ma-0(v-model='currentselect' :value='item' :value-comparator="(a, b) => a.id === b.id" :color="checkbox_setting")
                      v-list-item-content.pa-0(style="display: inline;" color="rgba(0,0,0,.87)")
                        v-avatar(size='20' max-height='20' :color='getColorFromKnowledgeName(item.name)' left class="mr-2")
                          span(style='padding-bottom:1px;') {{item.name.slice(0,1)}}
                        span(style='color:#444444; font-weight: 400; font-size: 14px;') {{item.name.split('@')[0]}}
                      v-list-item-action.ma-0
                        v-hover(v-slot="{ hover }")
                          v-btn(icon x-small @click.stop="toggleFavorite(item)")
                            v-icon(size='20' :color="item.is_favorite ? '#14C6DE' : (hover ? '#bbb' : 'transparent')") {{ item.is_favorite ? 'mdi-star' : 'mdi-star-outline' }}
      // 在Desktop狀態下顯示
      v-menu(
        offset-y
        persistent
        bottom
        transition="slide-y-transition d-flex align-center"
        content-class="knowledge-list-menu"
        :close-on-content-click="false"
        v-model="menuOpen"
        eager
        v-else
      )
        template(v-slot:activator="{ on, attrs }")
          v-btn.kw-box.d-flex.justify-start.align-center.custom-btn(
            color="transparent"
            icon
            v-bind="attrs"
            v-on="on"
            :title="$t('PORTAL.ADD_TOOL_KNOWLEDGE')"
          )
            v-icon(size="24" color="#666666") mdi-plus
        div.knowledge-dropdown
          // --------- 搜尋網頁 ---------
          template(v-if="$store.state.webSearchEnabled && $store.state.portalWebSearchEnabled")
            div.kd-section(@click.stop="canSearchWeb = !canSearchWeb")
              div.kd-sec-icon
                v-img(contain height="20px" width="20px" src="@/assets/images/search_web.svg")
              span.kd-sec-label {{$t('AGENT.SEARCH_WEB')}}
              div.kd-switch
                div.kd-switch-track(:class="{ on: canSearchWeb }" :style="switchTrackStyle(canSearchWeb)")
                  div.kd-switch-knob
                span.kd-switch-label {{ canSearchWeb ? $t("GPT_KNOWLEDGE.OPEN_LIB") : $t("GPT_KNOWLEDGE.CLOSE_LIB") }}
              div.kd-caret.kd-caret-hidden
            div.kd-divider
          // --------- 知識庫 ---------
          div.kd-section(:class="{ expanded: kbExpanded }" @click.stop="kbExpanded = !kbExpanded")
            div.kd-sec-icon
              v-img(contain height="20px" width="20px" src="@/assets/images/knowledge_select.svg")
            span.kd-sec-label {{$t('AGENT.KNOWLEDGE_LIBS')}}
            div.kd-switch(@click.stop="canUseKB = !canUseKB")
              div.kd-switch-track(:class="{ on: canUseKB }" :style="switchTrackStyle(canUseKB)")
                div.kd-switch-knob
              span.kd-switch-label {{ canUseKB ? $t("GPT_KNOWLEDGE.OPEN_LIB") : $t("GPT_KNOWLEDGE.CLOSE_LIB") }}
            div.kd-caret
              v-icon(size="20" color="#888888") mdi-chevron-right
          div.kd-collapse(:class="{ open: kbExpanded && canUseKB }")
            div.kd-collapse-inner
              // -------- 全選列（右側為「★ 收藏」圖例，純說明不可點）--------
              div.kd-item.kd-all-row(@click.stop="activeTriggerAllKM")
                div.kd-cbx
                  div.kd-cbx-box(:class="kdAllState" :style="cbxStyle(kdAllState)")
                    v-icon(v-if="cbxIcon(kdAllState)" size="12" color="#FFFFFF") {{ cbxIcon(kdAllState) }}
                span.kd-item-label {{$t('GENERAL.SELECTALL')}}
                span.kd-fav-legend
                  v-icon(size="16" color="#07B2D3") mdi-star
                  | {{$t('PORTAL.FAVORITE_SHORT')}}
              // -------- 收藏（釘選）在最上方，其餘為資料夾樹與私人知識庫 --------
              template(v-for="row in kdRows")
                div.kd-pin-divider(v-if="row.kind === 'divider'" :key="row.key")
                div.kd-group-label(v-else-if="row.kind === 'label'" :key="row.key") {{ row.text }}
                // 資料夾（不提供收藏）
                div.kd-item(
                  v-else-if="row.kind === 'folder'"
                  :key="row.key"
                  :style="{ paddingLeft: (16 + row.depth * 14) + 'px' }"
                  @click.stop="toggleFolder(row.node.id)"
                )
                  div.kd-cbx(@click.stop="toggleFolderSelection(row.node)")
                    div.kd-cbx-box(:class="folderCbxState(row.node.id)" :style="cbxStyle(folderCbxState(row.node.id))")
                      v-icon(v-if="cbxIcon(folderCbxState(row.node.id))" size="12" color="#FFFFFF") {{ cbxIcon(folderCbxState(row.node.id)) }}
                  div.kd-tri(:class="{ open: expandedFolderIds.includes(String(row.node.id)) }")
                    v-icon(size="20" color="#CCCCCC") mdi-menu-right
                  v-img.kd-folder-ic(src="@/assets/images/folder-btn.svg" max-height="20" max-width="20" contain)
                  span.kd-item-label(@mouseenter="showTip($event, row.label)") {{ row.label }}
                // 知識庫
                div.kd-item(
                  v-else
                  :key="row.key"
                  :style="{ paddingLeft: (16 + row.depth * 14) + 'px' }"
                  @click.stop="toggleLibSelection(row.item)"
                )
                  div.kd-cbx
                    div.kd-cbx-box(:class="isLibSelected(row.item.id) ? 'checked' : 'off'" :style="cbxStyle(isLibSelected(row.item.id) ? 'checked' : 'off')")
                      v-icon(v-if="isLibSelected(row.item.id)" size="12" color="#FFFFFF") mdi-check
                  div.kd-tri(v-if="row.depth > 0")
                  div.kd-rbadge(:style="{ background: getColorFromKnowledgeName(row.item.name) }") {{ row.item.name.slice(0,1) }}
                  span.kd-item-label(@mouseenter="showTip($event, row.label)") {{ row.label }}
                  v-icon.kd-star(
                    :class="{ filled: localFavoriteIds.includes(row.item.id) }"
                    size="20"
                    :color="localFavoriteIds.includes(row.item.id) ? '#07B2D3' : '#CCCCCC'"
                    :title="localFavoriteIds.includes(row.item.id) ? '取消收藏' : '收藏'"
                    @click.stop="toggleFavorite(row.item)"
                  ) {{ localFavoriteIds.includes(row.item.id) ? 'mdi-star' : 'mdi-star-outline' }}
      v-btn.mr-2(icon :title="$t('AGENT.INSTRUCTION')" @click="handleOpenInstruction" :style="{backgroundColor: openInstruction ? '#D6F7FF' : 'transparent'}")
        v-img(contain height="21.5px" src="@/assets/images/instruction-icon.svg" width="21px")
      v-btn.mr-2(icon :title="$t('AGENT_FILE_ATTACHMENT.ATTACHMENT')" @click="$refs.multipleFileRef.selectFiles()" style="background: transparent")
        v-img(contain height="21.5px" src="@/assets/images/attachment_file.svg" width="21px")
      v-chip.simple-agent-chip(v-if="Object.keys(agent_to_userInput).length > 0" close @click:close="clearAgent" small color="#D6F7FF")
        v-img(:src="select_icon_obj.path" max-width="18px" width="18px" height="18px" style="margin-left: -8px; margin-right: 5px")
        span.ellipsis-single {{agent_to_userInput.agent_name}}
      v-spacer
      v-btn(:disabled="!hasText || isLicenseBlocking" class="send-button  d-flex justify-end align-center" icon @click="sendMessage")
        v-img(:src="sendButtonIcon" contain height="32" width="32")
    div.top-hr-line.d-flex.flex-column.mt-1.mb-4(v-if="openInstruction")
      div.pl-6.py-1(style='font-size:14px;') {{ $t("AGENT.INSTRUCTION") }}
      div.px-6.thread-input-maxwidth
        textarea.input-field-upper.custom-height.h5-en-regular.ma-0.pa-2.custom-text-field.v-input__control.auto-textarea-boder(v-model="general_instructions" rows="3" style="resize:none; height: 85px;")
</template>

<script>
import i18n from '/common/plugins/vue-i18n.js';
import KnowledgeList from "./KnowledgeList.vue";
import multipleFileThumbnail from "../Common/multipleFileThumbnail.vue";
import PreferenceService from "@/services/PreferenceService";
import KnowledgeLibraryService from "@/services/KnowledgeLibraryService";


export default {
    components: {
        KnowledgeList,
        multipleFileThumbnail,
    },
    data() {
    return {
      menuOpen: false,
      // 「＋」面板中知識庫區塊是否展開
      kbExpanded: true,
      message: "",
      sendIconA: require("@/assets/images/send.svg"),
      sendIconB: require("@/assets/images/send_no_tex.svg"),
      canSearchWeb: false,
      canUseKB: true,
      KnowledgeListData: this.selectedKnowledgeLibs,
      ishover: false,
      drawer:false,
      general_instructions:'',
      openInstruction:false,
      files: [],
      uploadedFiles: [],
      isUploading: false,
      acceptFileTypes: '.pdf,.docx,.pptx,.jpg,.jpeg,.png',
      select_icon_obj: { name: "default", path: require("@/assets/images/agent_icon/default.png") },
      formRules: {
        massTextAreaRule: [
            (v) => !!v || i18n.t('RULE.RULE_R'),
            (v) => /^.{0,1000}$/s.test(v) || i18n.t('RULE.RULE_10000'),
        ],
      },
      unselectAllKM: false,
      // 客製外觀參數
      toggle_setting: document.documentElement.style.getPropertyValue('--toggle_setting'),
      checkbox_setting: document.documentElement.style.getPropertyValue('--checkbox_setting'),
      // 記錄已展開的資料夾 id（Task 10）
      expandedFolderIds: [],
      // 本地收藏 ID 清單（同 KnowledgeList.vue 的做法，避免 flattenedTree 淺複製導致響應式失效）
      localFavoriteIds: [],
    };
  },
  props: {
    knowledgeList: {
      type: Array,
      required:true,
    },
    knowledgeListPrivate: {
      type: Array,
      required:true,
    },
    selectedKnowledgeLibs: {
      type:Array,
      required: true
    },
    allKnowledgeColor: {
      type: Array,
      required:true,
    },
    agent_to_userInput: {
      type: Object,
    },
    folderTreeOptions:{
      type:Array,
      required: true,
      default: () => []
    },
  },
  computed: {
    hasText() {
      return this.message.trim().length > 0;
    },
    // 授權停止服務或無效時，送出按鈕無條件呈現停用外觀（有沒有文字都一樣）。
    // 這只是給使用者看的提示，真正擋住送出的是 sendMessage() 的前置檢查。
    isLicenseBlocking() {
      return this.$store.getters.isLicenseBlocking;
    },
    sendButtonIcon() {
      return this.hasText ? this.sendIconA : this.sendIconB;
    },
    currentselect: {
      get () { return this.selectedKnowledgeLibs },
      set (val) { this.$emit('update:selectedKnowledgeLibs', val) }
    },
    use_knowledge_source: {
      get() {
          return this.canUseKB
      },
      set(val) {
          this.$emit('useknowledgesetting', val)
      }
    },
    // Folder-first 樹狀結構攤平為列表（Task 10）
    flattenedTree() {
      const result = []
      const flatten = (nodes, depth = 0) => {
        for (const node of (nodes || [])) {
          result.push({ ...node, depth })
          if (node.type === 'folder' && this.expandedFolderIds.includes(String(node.id))) {
            flatten(node.children || [], depth + 1)
          }
        }
      }
      flatten(this.folderTreeOptions)
      return result
    },
    // 收藏區：依 localFavoriteIds 過濾，確保 flattenedTree 淺複製不影響響應式
    knowledgeFavorites() {
      return [...this.knowledgeList, ...this.knowledgeListPrivate]
        .filter(item => this.localFavoriteIds.includes(item.id))
    },
    // 「＋」面板全選列狀態：checked / indeterminate / off
    kdAllState() {
      if (this.selectAllKMCheck()) return 'checked'
      if (this.selectSomeKMCheck()) return 'indeterminate'
      return 'off'
    },
    // 「＋」面板的列：收藏（釘選）移到最上方並以分隔線隔開，
    // 已收藏的知識庫不再出現在原本的資料夾位置；其後是資料夾樹與私人知識庫
    kdRows() {
      const rows = []
      const favorites = this.knowledgeFavorites
      favorites.forEach(item => {
        rows.push({ kind: 'library', key: `fav-${item.id}`, depth: 0, item, label: item.name.split('@')[0] })
      })
      if (favorites.length) rows.push({ kind: 'divider', key: 'fav-divider' })
      this.flattenedTree.forEach(node => {
        if (node.type === 'folder') {
          rows.push({ kind: 'folder', key: `folder-${node.id}`, depth: node.depth, node, label: node.name })
        } else if (node.type === 'library') {
          if (this.localFavoriteIds.includes(node.id)) return
          const item = this.libraryNodeMap[node.id] || node
          rows.push({ kind: 'library', key: `lib-${node.id}`, depth: node.depth, item, label: item.name.split('@')[0] })
        }
      })
      const privateItems = this.knowledgeListPrivate.filter(item => !this.localFavoriteIds.includes(item.id))
      if (privateItems.length) {
        rows.push({ kind: 'label', key: 'private-label', text: this.$t('PORTAL.MY_KNOWLEDGE') })
        privateItems.forEach(item => {
          rows.push({ kind: 'library', key: `private-${item.id}`, depth: 0, item, label: item.name.split('@')[0] })
        })
      }
      return rows
    },
    // 建立 library id → 原始 folderTreeOptions 節點的映射表
    // 確保 v-checkbox 的 :value 永遠使用穩定的物件 reference，
    // 避免 flattenedTree recompute（展開/收合資料夾）時產生新 spread 物件，
    // 觸發 Vuetify 2 的 value watcher 把 currentselect 覆蓋掉。
    libraryNodeMap() {
      const map = {}
      const traverse = (nodes) => {
        for (const node of (nodes || [])) {
          if (node.type === 'library') {
            map[node.id] = node
          } else if (node.type === 'folder') {
            traverse(node.children || [])
          }
        }
      }
      traverse(this.folderTreeOptions)
      return map
    },
  },
  mounted(){
    this.autoTextareaGrow();
  },
  async created() {
    this.loading = false;
    await this.getPortalColorSetting();
  },
  methods: {
    async getPortalColorSetting() {
      let color_setting;
      await PreferenceService.getPortalColorSetting().then((response)=>{
        color_setting = response.data;
        if (color_setting) {
          this.toggle_setting = color_setting.toggle_setting;
          this.checkbox_setting = color_setting.checkbox_setting;
        } else {
          this.toggle_setting = "#14C6DE";
          this.checkbox_setting = "#14C6DE";
        }
      })
    },
    // ===== 全選邏輯（Task 10，使用 Set 計算唯一 ID）=====
    selectAllKMCheck(){
      const uniqueIds = new Set([
        ...this.knowledgeList.map(i => i.id),
        ...this.knowledgeListPrivate.map(i => i.id),
      ])
      return uniqueIds.size > 0 && this.currentselect.length === uniqueIds.size
    },
    selectSomeKMCheck(){
      return this.currentselect.length > 0 && !this.selectAllKMCheck()
    },
    selectALLKMIconDesider(){
      if (this.selectAllKMCheck()){
        this.unselectAllKM = false;
        return 'mdi-checkbox-marked'
      }else if(this.selectSomeKMCheck()){
        this.unselectAllKM = false;
        return 'mdi-minus-box'
      }else{
        this.unselectAllKM = true;
        return 'mdi-checkbox-blank-outline'
      }
    },
    // 全選 / 全取消（使用 Map 去重，Task 10）
    activeTriggerAllKM(){
      if (this.selectAllKMCheck() || this.selectSomeKMCheck()){
        this.$emit('update:selectedKnowledgeLibs', [])
      } else {
        const seen = new Map()
        ;[...this.knowledgeList, ...this.knowledgeListPrivate].forEach(item => {
          if (!seen.has(item.id)) seen.set(item.id, item)
        })
        this.$emit('update:selectedKnowledgeLibs', [...seen.values()])
      }
    },

    // ===== 「＋」面板輔助方法 =====
    switchTrackStyle(on) {
      return on && this.toggle_setting ? { background: this.toggle_setting } : null
    },
    cbxStyle(state) {
      return state !== 'off' && this.checkbox_setting
        ? { background: this.checkbox_setting, borderColor: this.checkbox_setting }
        : null
    },
    cbxIcon(state) {
      if (state === 'checked') return 'mdi-check'
      if (state === 'indeterminate') return 'mdi-minus'
      return ''
    },
    // 資料夾勾選狀態（none / all / some）對應成 off / checked / indeterminate
    folderCbxState(folderId) {
      const state = this.getFolderCheckState(folderId)
      if (state === 'all') return 'checked'
      if (state === 'some') return 'indeterminate'
      return 'off'
    },
    isLibSelected(id) {
      return this.currentselect.some(s => s.id === id)
    },
    toggleLibSelection(item) {
      if (this.isLibSelected(item.id)) {
        this.$emit('update:selectedKnowledgeLibs', this.currentselect.filter(s => s.id !== item.id))
      } else {
        this.$emit('update:selectedKnowledgeLibs', [...this.currentselect, item])
      }
    },
    // 長名稱以 … 截斷時，才用瀏覽器原生 tooltip 顯示完整名稱
    showTip(e, text) {
      const el = e.currentTarget
      el.title = el.scrollWidth > el.clientWidth ? text : ''
    },

    // ===== 樹狀節點縮排樣式（depth > 0 加左 guide line）=====
    treeNodeStyle(node) {
      if (node.depth === 0) {
        return { paddingLeft: node.type === 'folder' ? '6px' : '0', minHeight: '36px' }
      }
      const ml = (node.depth - 1) * 16 + 14
      return {
        marginLeft: ml + 'px',
        // borderLeft: '2px solid #e0e0e0',
        paddingLeft: node.type === 'folder' ? '6px' : '0',
        minHeight: '36px',
      }
    },

    // ===== 資料夾展開 / 收合（Task 10）=====
    toggleFolder(folderId) {
      const id = String(folderId)
      const idx = this.expandedFolderIds.indexOf(id)
      if (idx === -1) {
        this.expandedFolderIds.push(id)
      } else {
        this.expandedFolderIds.splice(idx, 1)
      }
    },

    // ===== 資料夾 Checkbox 狀態（Task 10）=====
    getAllLibsUnderNode(node) {
      const libs = []
      const traverse = (children) => {
        for (const child of (children || [])) {
          if (child.type === 'library') {
            libs.push(child)
          } else if (child.type === 'folder') {
            traverse(child.children || [])
          }
        }
      }
      traverse(node.children || [])
      return libs
    },
    getFolderCheckState(folderId) {
      const rawNode = this.findNodeInTree(this.folderTreeOptions, String(folderId))
      if (!rawNode) return 'none'
      const libs = this.getAllLibsUnderNode(rawNode)
      if (libs.length === 0) return 'none'
      const selectedCount = libs.filter(lib =>
        this.currentselect.some(s => s.id === lib.id)
      ).length
      if (selectedCount === 0) return 'none'
      if (selectedCount === libs.length) return 'all'
      return 'some'
    },
    getFolderCheckIcon(folderId) {
      const state = this.getFolderCheckState(folderId)
      if (state === 'all') return 'mdi-checkbox-marked'
      if (state === 'some') return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    toggleFolderSelection(folderNode) {
      const rawNode = this.findNodeInTree(this.folderTreeOptions, String(folderNode.id))
      if (!rawNode) return
      const libs = this.getAllLibsUnderNode(rawNode)
      if (libs.length === 0) return
      const state = this.getFolderCheckState(folderNode.id)
      if (state === 'all') {
        const libIds = new Set(libs.map(l => l.id))
        this.$emit('update:selectedKnowledgeLibs', this.currentselect.filter(s => !libIds.has(s.id)))
      } else {
        const alreadySelectedIds = new Set(this.currentselect.map(s => s.id))
        const toAdd = libs.filter(l => !alreadySelectedIds.has(l.id))
        this.$emit('update:selectedKnowledgeLibs', [...this.currentselect, ...toAdd])
      }
    },
    findNodeInTree(nodes, id) {
      for (const node of (nodes || [])) {
        if (String(node.id) === id) return node
        if (node.type === 'folder') {
          const found = this.findNodeInTree(node.children || [], id)
          if (found) return found
        }
      }
      return null
    },

    // ===== 收藏功能（Task 11）=====
    _syncFavoriteState(id, isFavorite) {
      const idx = this.localFavoriteIds.indexOf(id)
      if (isFavorite && idx === -1) this.localFavoriteIds.push(id)
      else if (!isFavorite && idx !== -1) this.localFavoriteIds.splice(idx, 1)
      // 同步原始物件的 is_favorite
      const original = [...this.knowledgeList, ...this.knowledgeListPrivate].find(k => k.id === id)
      if (original) this.$set(original, 'is_favorite', isFavorite)
    },
    async toggleFavorite(item) {
      const wasFavorite = this.localFavoriteIds.includes(item.id)
      const newVal = !wasFavorite
      this._syncFavoriteState(item.id, newVal)
      try {
        if (newVal) {
          await KnowledgeLibraryService.addFavorite(item.id)
        } else {
          await KnowledgeLibraryService.removeFavorite(item.id)
        }
      } catch (e) {
        this._syncFavoriteState(item.id, wasFavorite)
      }
    },

    autoTextareaGrow(){
      let el = this.$refs.autoTextarea;
      if (!el) return;
      el.style.height = 'auto';
      let maxHeight = 120;
      if(el.scrollHeight > maxHeight){
        el.style.height = maxHeight + 'px';
        el.style.overflowerY = 'auto';
      }else{
        el.style.height = el.scrollHeight + 'px';
        el.style.overflowerY = 'hidden';
      }
    },
    async sendMessage() {
      // 送出按鈕與 Enter 鍵都走這裡，所以擋在這一處就兩種操作都擋得住——
      // 只停用按鈕擋不住 Enter。擋下時不清空 message，使用者輸入的內容保留。
      // 是否阻擋由 store 統一判斷（含送出前重新查詢一次），元件不自己比對狀態碼。
      if (await this.$store.dispatch('refreshLicenseBlocking')) {
        return;
      }
      if (this.hasText) {
        let data = {
          "text": this.message,
          "category": this.currentselect,
          "general_instructions": this.general_instructions,
          "attchements": this.uploadedFiles,
          "use_web_search": this.canSearchWeb,
          "use_knowledge_lib": this.canUseKB,
        }
        this.$emit("sendmessage", data);
        this.message = "";
      }
    },
    clearAgent() {
      this.general_instructions = "";
      this.files = [];
      this.$emit("clearAgent");
    },
    addAttachmentData(data){
      this.uploadedFiles = data;
    },
    showErrorDialog(message){
      this.$emit("showErrorDialog", message)
    },
    handleOpenInstruction(){
      this.openInstruction = !this.openInstruction;
    },
    handleThreadDragOver(event) {
    },
    handleThreadDragLeave() {
      // 確認滑鼠真的離開容器，避免子元素觸發誤判
    },
    async handleThreadDrop(event) {
      const dropped = event.dataTransfer?.files || [];
      if (!dropped.length || !this.$refs.multipleFileRef) return;
      const acceptList = this.acceptFileTypes.split(',').map(ext => ext.trim().toLowerCase());
      for (let i = 0; i < dropped.length; i++) {
        const file = dropped[i];
        const ext = '.' + file.name.toLowerCase().split('.').pop();
        if (acceptList.includes(ext)) {
          await this.$refs.multipleFileRef.addFileFromPaste(file);
        }
      }
    },
    mapping_icon_path(icon_name){
        if (icon_name == 'award') {
            return require("@/assets/images/agent_icon/award.png")
        } else if (icon_name == 'cloud'){
            return require("@/assets/images/agent_icon/cloud.png")
        } else if (icon_name == 'construction'){
            return require("@/assets/images/agent_icon/construction.png")
        } else if (icon_name == 'customerservice'){
            return require("@/assets/images/agent_icon/customerservice.png")
        } else if (icon_name == 'finance'){
            return require("@/assets/images/agent_icon/finance.png")
        } else if (icon_name == 'generate'){
            return require("@/assets/images/agent_icon/generate.png")
        } else if (icon_name == 'humanresource'){
            return require("@/assets/images/agent_icon/humanresource.png")
        } else if (icon_name == 'idea'){
            return require("@/assets/images/agent_icon/idea.png")
        } else if (icon_name == 'knowledge'){
            return require("@/assets/images/agent_icon/knowledge.png")
        } else if (icon_name == 'message'){
            return require("@/assets/images/agent_icon/message.png")
        } else if (icon_name == 'metal'){
            return require("@/assets/images/agent_icon/metal.png")
        } else if (icon_name == 'policy'){
            return require("@/assets/images/agent_icon/policy.png")
        } else if (icon_name == 'questionandanswer'){
            return require("@/assets/images/agent_icon/questionandanswer.png")
        } else if (icon_name == 'report'){
            return require("@/assets/images/agent_icon/report.png")
        } else if (icon_name == 'robot'){
            return require("@/assets/images/agent_icon/robot.png")
        } else if (icon_name == 'searchimage'){
            return require("@/assets/images/agent_icon/searchimage.png")
        } else if (icon_name == 'setting'){
            return require("@/assets/images/agent_icon/setting.png")
        } else if (icon_name == 'shopping_cart'){
            return require("@/assets/images/agent_icon/shopping_cart.png")
        } else if (icon_name == 'speclist'){
            return require("@/assets/images/agent_icon/speclist.png")
        } else if (icon_name == 'translate'){
            return require("@/assets/images/agent_icon/translate.png")
        } else if (icon_name == 'conversation'){
            return require("@/assets/images/agent_icon/conversation.png")
        } else if (icon_name == 'record'){
            return require("@/assets/images/agent_icon/record.png")
        } else if (icon_name == 'target'){
            return require("@/assets/images/agent_icon/target.png")
        } else if (icon_name == 'house'){
            return require("@/assets/images/agent_icon/house.png")
        } else if (icon_name == 'land_property'){
            return require("@/assets/images/agent_icon/land_property.png")
        } else if (icon_name == 'mail_reply'){
            return require("@/assets/images/agent_icon/mail_reply.png")
        } else if (icon_name == 'search_web'){
            return require("@/assets/images/agent_icon/search_web.png")
        } else {
            return require("@/assets/images/agent_icon/default.png")
        }
    },
    getColorFromKnowledgeName(knowledge_name){
      let color_data = this.allKnowledgeColor.find(item=>item.name == knowledge_name);
      return color_data ? color_data.color : 'aliceBlue';
    },
  },
  watch: {
    knowledgeList: {
      immediate: true,
      handler(list) {
        list.forEach(item => {
          const idx = this.localFavoriteIds.indexOf(item.id)
          if (item.is_favorite && idx === -1) this.localFavoriteIds.push(item.id)
          else if (!item.is_favorite && idx !== -1) this.localFavoriteIds.splice(idx, 1)
        })
      },
    },
    knowledgeListPrivate: {
      immediate: true,
      handler(list) {
        list.forEach(item => {
          const idx = this.localFavoriteIds.indexOf(item.id)
          if (item.is_favorite && idx === -1) this.localFavoriteIds.push(item.id)
          else if (!item.is_favorite && idx !== -1) this.localFavoriteIds.splice(idx, 1)
        })
      },
    },
    message(){
      this.$nextTick(this.autoTextareaGrow);
    },
    selectedKnowledgeLibs: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.currentselect  = newVal
      }
    },
    agent_to_userInput: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.general_instructions = newVal.instruction;
        this.files = newVal.attach_document;
        this.uploadedFiles = newVal.attach_document;
        if(newVal.use_web_search === undefined){
          this.canSearchWeb = false;
        }else{
          this.canSearchWeb = newVal.use_web_search;
        }
        if(newVal.use_knowledge_lib === undefined){
          this.canUseKB = true;
        }else{
          this.canUseKB = newVal.use_knowledge_lib;
        }
      }
    },
    "agent_to_userInput.icon_path":function(e){
        if (e){
            this.select_icon_obj = { name: e, path: this.mapping_icon_path(e) }
        } else {
            this.select_icon_obj = { name: "default", path: require("@/assets/images/agent_icon/default.png") }
        }
    },
    canUseKB: {
      handler(newVal) {
          this.$emit('useknowledgesetting', newVal);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/portal/typography.scss";
@import "@/style/portal/component.scss";

.custom-btn:active .avatar-effect,
.custom-btn:focus .avatar-effect {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  transition: background-color 0.2s ease-in-out;
}

.v-input__control .v-input__underlined {
  transition: none !important;
}

.v-menu__content {
  box-shadow: 0px 0px 8px #9999994D;
}
// ===== 「＋」下拉面板（UpGPT Portal 設計稿）=====
.knowledge-dropdown {
  // 寬度同設計稿 320px；高度隨內容延伸，最高為視窗的 70%，超過才捲動
  width: 320px;
  max-width: 90vw;
  max-height: 70vh;
  background: #FFFFFF;
  border-radius: 4px;
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  font-family: "Segoe UI", "Noto Sans TC", system-ui, sans-serif;
  color: #444444;
}
.knowledge-dropdown::-webkit-scrollbar {
  width: 6px;
}
.knowledge-dropdown::-webkit-scrollbar-track {
  background: #F4F4F4;
}
.knowledge-dropdown::-webkit-scrollbar-thumb {
  background: rgba(153, 153, 153, 0.3);
  border-radius: 10px;
}
// 區塊標題（搜尋網頁 / 知識庫）
.kd-section {
  min-height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 16px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1.6;
  letter-spacing: .5px;
  &:hover { background: #F4F4F4; }
}
.kd-sec-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
}
.kd-sec-label { flex: 1; }
.kd-divider { height: 1px; background: #E8E8E8; flex-shrink: 0; }
.kd-caret {
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  &.kd-caret-hidden { visibility: hidden; }
  .v-icon { transition: transform .2s ease; }
}
.kd-section.expanded .kd-caret .v-icon { transform: rotate(90deg); }
// 開關：24×12 track、thumb 7.2px
.kd-switch { display: flex; align-items: center; gap: 4px; flex-shrink: 0; }
.kd-switch-track {
  width: 24px;
  height: 12px;
  border-radius: 999px;
  background: #CCCCCC;
  position: relative;
  flex-shrink: 0;
  transition: background .15s;
  &.on { background: #14C6DE; }
}
.kd-switch-knob {
  width: 7.2px;
  height: 7.2px;
  border-radius: 50%;
  background: #FFFFFF;
  position: absolute;
  top: 2.4px;
  left: 2.4px;
  transition: left .15s;
}
.kd-switch-track.on .kd-switch-knob { left: 14.4px; }
.kd-switch-label { font-size: 16px; letter-spacing: .5px; min-width: 30px; }
// 展開 / 收合
.kd-collapse {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows .2s ease;
  flex-shrink: 0;
  &.open { grid-template-rows: 1fr; }
}
.kd-collapse-inner { overflow: hidden; min-height: 0; }
// 列
.kd-item {
  min-height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 16px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1.6;
  letter-spacing: .5px;
  &:hover { background: #F4F4F4; }
}
.kd-item-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.kd-group-label {
  padding: 4px 16px;
  font-size: 14px;
  color: #444444;
}
// 全選列：上線 Grey-200、下線 Grey-100
.kd-all-row {
  border-top: 1px solid #E8E8E8;
  border-bottom: 1px solid #F4F4F4;
}
.kd-fav-legend {
  margin-left: auto;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: .5px;
  cursor: default;
  pointer-events: none;
}
// 收藏區與下方知識庫的分隔線
.kd-pin-divider { height: 1px; background: #F4F4F4; margin: 0 16px; flex-shrink: 0; }
// Checkbox：16×16、radius 2px、border 1.5px
.kd-cbx { width: 24px; height: 24px; flex-shrink: 0; display: grid; place-items: center; }
.kd-cbx-box {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  border: 1.5px solid #666666;
  display: grid;
  place-items: center;
  background: #FFFFFF;
  &.checked, &.indeterminate { background: #14C6DE; border-color: #14C6DE; }
}
.kd-tri {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  .v-icon { transition: transform .2s ease; }
  &.open .v-icon { transform: rotate(90deg); }
}
.kd-folder-ic { width: 20px; height: 20px; flex: 0 0 20px; }
.kd-rbadge {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 12px;
  color: #444444;
  flex-shrink: 0;
}
// 星號：未收藏平常隱藏，hover 該列才顯示外框星星；已收藏永遠顯示實心
.kd-star {
  flex-shrink: 0;
  cursor: pointer;
  &:not(.filled) { visibility: hidden; }
}
.kd-item:hover .kd-star:not(.filled) { visibility: visible; }
.tree-folder-row {
  cursor: pointer;
  &:hover {
    background: rgba(0,0,0,0.03);
  }
}
.tree-node-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 140px;
}
::v-deep .v-list-item::before {
  display: none !important;
}
::v-deep .v-list-item .v-ripple__container {
  display: none !important;
}
.theme--light.v-input {
  color: rgba(0, 0, 0, 0.54);
}
.partial-kmlist ::v-deep .v-input__control  {
  flex-direction: row;
  flex-wrap: nowrap;
  }
.partial-kmlist-mobile ::v-deep .v-input__control  {
  flex-direction: row;
  flex-wrap: nowrap;
  }
.partial-kmlist-mobile ::v-deep .v-input--selection-controls__input {
  width: 20px;
  height: 20px;
  margin-right: 4px;
  .v-icon {
      font-size: 20px !important;
  }
}
.ellipsis-single{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
  display: inline-block;
}
.private-list.v-list-item {
  min-height: unset;
}
.partial-kmlist-mobile {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.partial-kmlist-mobile::-webkit-scrollbar {
  width: 6px;
}
.partial-kmlist-mobile::-webkit-scrollbar-track {
  background: #F4F4F4 !important;
}
.partial-kmlist-mobile::-webkit-scrollbar-thumb {
  background: rgba(153, 153, 153, 0.3);
  border-radius: 10px;
}
</style>
